import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CoreTrackingFacade } from '@iot-platform/core';
import { TrackingEventIds } from '@iot-platform/models/dashboards';

import { NumberFormatPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-feature-dashboards-dashboards-data-table-dialog',
  imports: [CommonModule, MatButtonModule, MatCardModule, MatIconModule, MatToolbarModule, TranslatePipe, NumberFormatPipe],
  templateUrl: './dashboards-data-table-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboards-data-table-dialog.component.scss'
})
export class DashboardsDataTableDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<DashboardsDataTableDialogComponent>);
  public data: {
    data: { name: string; count: number; color: string | null }[];
    title: string;
    total: number;
    showLegends: boolean;
  } = inject(MAT_DIALOG_DATA);
  protected readonly trackingFacade: CoreTrackingFacade = inject(CoreTrackingFacade);

  ngOnInit() {
    this.trackingFacade.trackEventById(TrackingEventIds.OPEN_DASHBOARD_DATA_TABLE_DIALOG, { widgetTitle: this.data.title });
  }

  exit() {
    this.dialogRef.close();
  }
}
